/* Native scrolling reviews: swipe, trackpad and keyboard, without autoplay controls. */
(() => {
  const initialise = root => root.querySelectorAll('[data-mg-experiences]').forEach(section => {
    if (section.dataset.ready) return;
    const track = section.querySelector('[data-review-cards]');
    const cards = [...section.querySelectorAll('[data-review-card]')];
    const controls = section.querySelector('[data-review-controls]');
    const previous = section.querySelector('[data-review-prev]');
    const next = section.querySelector('[data-review-next]');
    const count = section.querySelector('[data-review-count]');
    if (!track || !cards.length || !controls || !previous || !next || !count) return;
    section.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    let frame;
    const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    const render = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.max(0, track.scrollLeft);
      const index = Math.min(cards.length - 1, Math.round(position / Math.max(1,step())));
      count.textContent = String(index + 1).padStart(2,'0') + ' / ' + String(cards.length).padStart(2,'0');
      previous.disabled = position <= 2;
      next.disabled = position >= max - 2;
      controls.hidden = max <= 2;
    };
    const move = direction => track.scrollBy({left:direction * step(),behavior:reduced.matches?'instant':'smooth'});
    previous.addEventListener('click',() => move(-1));
    next.addEventListener('click',() => move(1));
    track.addEventListener('scroll',() => {cancelAnimationFrame(frame);frame=requestAnimationFrame(render);},{passive:true});
    track.addEventListener('keydown',event => {
      if(event.target !== track)return;
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}
    });
    const resize = new ResizeObserver(render);resize.observe(track);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(section))resize.disconnect();});
    render();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialise(document));else initialise(document);
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();
